export default __webpack_public_path__ + "static/dateEnding-d42f52fe97be492650cac128d0d96ac8.svg";